<div *ngIf="current_info">
    <nb-card>
        <nb-card-header>{{current_info?.label.it}}</nb-card-header>
        <nb-card-body>
            <div
                class="info"
                [innerHTML]="current_info?.info.it"
            ></div>

            <youtube-player
                *ngIf="youtube_code"
                class="mt-4"

                videoId="{{youtube_code}}"
            ></youtube-player>

        </nb-card-body>
    </nb-card>
</div>
